
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'GDM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/GDM.vue